































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Emit, Watch } from "vue-property-decorator";

import CustomerNotification from "@/components/headers/customer-notifications";

import Header from "@/types/app/header";
import Notification, { notificationInitialValue } from "@/types/app/notifications";

import formatMoney from "@/utils/formatMoney";
import applyCondition from "@/utils/applyCondition";
import formatDate from "@/utils/formatDate";
import { truncate } from "@/utils/truncate";
import Endpoint from "@/utils/endpoint";
import { getNotifications } from "@/utils/getNotifications";

import ModalNewNotification from "@/views/notifications/new.vue";
import ModalNotification from "@/components/common/ModalNotification.vue";
import ModalNotificationSent from "@/components/common/NotificationSend.vue";
import ModalDeleteNotification from "@/components/common/ModalDeleteNotification.vue";
import ModalSuccess from "@/components/common/ModalSuccess.vue";
import ErrorService from "@/services/erroService";
import RefreshStore from "@/services/refreshStore";
const namespace = "customer";

@Component({
  components: {
    newNotification: ModalNewNotification,
    notification: ModalNotification,
    NotificationSent: ModalNotificationSent,
    notificationDelete: ModalDeleteNotification,
    ModalSuccess,
  },
  methods: {
    formatMoney,
    formatDate,
    truncate,
  },
})
export default class Notifications extends Vue {
  @Getter("getModalNewNotificationState", { namespace })
  modalNewNotificationState!: boolean;

  notifications: Notification[] = [];

  @Action("setModalNotificationState", { namespace })
  setModalNotificationState!: any;

  @Action("setModalNewNotificationState", { namespace })
  setModalNewNotificationState!: (modalIsVisible: boolean) => void;
  @Action("setNotificationState", { namespace })
  setNotificationState!: (notification: Notification) => void;

  private endpoint = new Endpoint();

  loadingNotifications = false;
  headers: Header[] = CustomerNotification.header;
  selectedNotifications: any[] = [];
  openSuccessModal = false;
  openSuccessModalMessage = "";
  titleFilter = "";
  descriptionFilter = "";
  hasAppUrlFilter = "";

  get hasSelectedNotifications() {
    return this.selectedNotifications.length > 0;
  }

  async mounted() {
      await this.handleNotifications();
    
  }

  @Watch("modalNewNotificationState")
  async handleNotifications() {
    if (!this.modalNewNotificationState) {
      this.loadingNotifications = true;

      this.notifications = await getNotifications(
        this.endpoint.notifications,
        "PushApp",
        this.$http
      );

      this.loadingNotifications = false;
    }
  }

  get filteredNotifications() {
    const conditions: any[] = [];
    if (this.titleFilter) {
      conditions.push((item: Notification) =>
        item.title.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
    }

    if (this.descriptionFilter) {
      conditions.push((item: Notification) =>
        item.description.toLowerCase().includes(this.descriptionFilter.toLowerCase())
      );
    }

    if (this.hasAppUrlFilter) {
      conditions.push((item: Notification) =>
        item.hasAppUrl
          .toString()
          .toLowerCase()
          .includes(this.hasAppUrlFilter.toLowerCase())
      );
    }
    return applyCondition<Notification>(this.notifications, conditions);
  }

  deleteNotifications() {
    this.$confirm("Do you really want to delete this select notification(s)?").then(
      (res) => {
        if (res) {
          const url = `${this.endpoint.notifications}`;
          const notificationIds = this.selectedNotifications.map((x) => x.id);
          this.loadingNotifications = true;
          this.$http
            .delete(`${url}`, { data: { notificationIds } })
            .then((res: any) => {
              
              this.notifications=  this.notifications.filter((p) => !notificationIds.some((m) => m == p.id))
              

              this.openSuccessModalMessage = "Deleted notification(s) with success!";
              this.selectedNotifications = [];
              this.openSuccessModal = true;
              this.loadingNotifications = false;
            })
            .catch((error) => {
              this.loadingNotifications = false;
              ErrorService.onError({
                status: -1,
                message: "Notifications:deletedNotifications",
                error,
              });
            });
        }
      }
    );
  }

  showNotification(notification: Notification) {
    this.setNotificationState(notification);
    this.setModalNewNotificationState(true);
  }

  showNewNotificationModal() {
    this.setNotificationState(notificationInitialValue);
    this.setModalNewNotificationState(true);
  }
}
